var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userId)?_c('div',{staticClass:"user-id"},[_c('div',[_c('div',[_c('svg-icon',{attrs:{"icon-class":'user-id'}})],1),_c('div',{staticClass:"user-id__id-container ellipsis"},[_vm._v(" ID #"),_c('CopyText',{attrs:{"label":_vm.ellipsisCenter(_vm.userId),"value":_vm.userId}})],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }